<app-page-title [heading]="heading" [icon]="icon"></app-page-title>

<div class="mb-3 card">
  <div class="card-header-tab card-header">
    <div class="card-header-title font-size-lg text-capitalize fw-normal">
      <i class="header-icon lnr-charts icon-gradient bg-happy-green"> </i>
      Cumulative Records
    </div>
  </div>
  <div class="g-0 row">
    <div class="col-sm-6 col-md-4 col-xl-4">
      <div class="card no-shadow rm-border bg-transparent widget-chart text-start">
        <div class="icon-wrapper rounded-circle">
          <div class="icon-wrapper-bg opacity-10 bg-warning"></div>
          <i class="pe-7s-car text-white opacity-8"></i></div>
        <div class="widget-chart-content">
          <div class="widget-subheading">Total Trips</div>
          <div class="widget-numbers">{{totalPackages}}</div>
          <!-- <div class="widget-description opacity-8 ">
            <div class="d-inline text-danger pe-1">
              <fa-icon [icon]="faAngleDown"></fa-icon>
              <span class="ps-1">54.1%</span>
            </div>
            Completed Trips
          </div> -->
        </div>
      </div>
      <div class="divider m-0 d-md-none d-sm-block"></div>
    </div>
    <div class="col-sm-6 col-md-4 col-xl-4">
      <div class="card no-shadow rm-border bg-transparent widget-chart text-start">
        <div class="icon-wrapper rounded-circle">
          <div class="icon-wrapper-bg opacity-9 bg-danger"></div>
          <i class="pe-7s-users  text-white"></i></div>
        <div class="widget-chart-content">
          <div class="widget-subheading">Total Customers</div>
          <div class="widget-numbers"><span>{{totalUsers }}</span></div>
          <!-- <div class="widget-description opacity-8 ">
            Grow Rate:
            <span class="text-info ps-1">
              <fa-icon [icon]="faAngleDown"></fa-icon>
                <span class="ps-1">14.1%</span>
            </span>
          </div> -->
        </div>
      </div>
      <div class="divider m-0 d-md-none d-sm-block"></div>
    </div>
    <div class="col-sm-12 col-md-4 col-xl-4">
      <div class="card no-shadow rm-border bg-transparent widget-chart text-start">
        <div class="icon-wrapper rounded-circle">
          <div class="icon-wrapper-bg opacity-9 bg-success"></div>
          <i class="pe-7s-settings text-white"></i></div>
        <div class="widget-chart-content">
          <div class="widget-subheading">Total On boarded Drivers</div>
          <div class="widget-numbers text-success"><span>{{totalApprovedDriversCount }}</span></div>
          <!-- <div class="widget-description ">
            Increased by
            <span class="text-warning ps-1">
              <fa-icon [icon]="faAngleUp"></fa-icon>
                <span class="ps-1">7.35%</span>
            </span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <div class="text-center d-block p-3 card-footer">

    <button class="btn-pill btn-shadow btn-wide fsize-1 btn btn-primary btn-lg dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
      <span class="me-2 opacity-7">
          <i class="icon icon-anim-pulse ion-ios-analytics-outline fa fa-cog fa-spin"></i>
      </span>
      <span class="me-1">View Complete Report</span>
    </button>
    <ul class="dropdown-menu">
      <li><a class="dropdown-item" href="dashboard/package">Trips</a></li>
      <li><a class="dropdown-item" href="dashboard/users">Users</a></li>
      <li><a class="dropdown-item" href="dashboard/drivers">Drivers</a></li>
    </ul>


    <!-- <button class="btn-pill btn-shadow btn-wide fsize-1 btn btn-primary btn-lg">
                  <span class="me-2 opacity-7">
                      <i class="icon icon-anim-pulse ion-ios-analytics-outline fa fa-cog fa-spin"></i>
                  </span>
      
      <span class="me-1">View Complete Report</span> 

    </button> -->
  </div>
</div>

<!-- Todays Registred Drivers -->
<div class="main-card mb-3 card">
  <div class="card-header">
    <div class="card-header-title font-size-lg text-capitalize fw-normal">Todays Registred Drivers</div>
  </div>
  <div class="table-responsive" style=" max-height: 300px; overflow-y: auto">
    <table class="align-middle text-truncate mb-0 table table-borderless table-hover">
      <thead>
      <tr>
        <th class="text-center">#</th>
        <th class="text-center">Name</th>
        <th class="text-center">City</th>
        <th class="text-center">Image</th>
        <th class="text-center">Vehicle Type</th>
        <th class="text-center">Status</th>
        <th class="text-center">Registration Time</th>
        <!-- <th class="text-center">Target Achievement</th>
        <th class="text-center">Actions</th> -->
      </tr>
      </thead>
      <tbody>
      <tr  *ngFor="let data of totalTodaysRegDrivers;  let i = index " >
        <td class="text-center text-muted" style="width: 80px;">{{i+1}}</td>
        <td class="text-center text-primary" style="width: 80px;">
          <!-- <img width="40" class="rounded-circle" src="./assets/images/pickupIMG.jpg" alt=""> -->
           {{data.firstName}} {{data.lastName}}
        </td>
        <td class="text-center">{{data.city}}</td>
        <!-- <td class="text-center text-primary" style="width: 80px;">
          <img width="30" class="rounded-circle" src="./assets/images/pickupIMG.jpg" alt="">
        </td> -->

        <td class="text-center text-primary" style="width: 80px;">
          <div [ngSwitch]="data.vehicleType">
            <img *ngSwitchCase="'2-Wheel- Upto 20kg'" width="50" class="rounded-circle" src="./assets/images/vehicleImages/2-wheeler.jpg" alt="2-Wheeler">
            <img *ngSwitchCase="'3-Wheel- Upto 500kg'" width="50" class="rounded-circle" src="./assets/images/vehicleImages/3-wheeler.jpg" alt="3-Wheeler">
            <img *ngSwitchCase="'4-Wheel (Mini-Truck) - Upto 750kg'" width="50" class="rounded-circle" src="./assets/images/vehicleImages/mini-truck.jpg" alt="4-Wheeler">
            <img *ngSwitchCase="'4-Wheel (Bolero) - Upto 1700kg'" width="50" class="rounded-circle" src="./assets/images/vehicleImages/pickupIMG.jpg" alt="4-Wheeler">
            <!-- <img *ngSwitchDefault width="30" class="rounded-circle" src="./assets/images/pickupIMG.jpg" alt="Default Vehicle"> -->
          </div>
        </td>        

        <td class="text-center text-success">{{data.vehicleType}}</td>
        <td class="text-center">
          <div class="badge rounded-pill" [ngClass]="{
            'bg-primary': data.verificationStatus == 1,
            'bg-danger': data.verificationStatus == 0
          }">
            {{ data.verificationStatus == 1 ? 'In Process' : 'Pending' }}
          </div>
        </td>
        <td class="text-center">
                                        <span class="pe-2 opacity-6">
                                            <i class="fa fa-business-time"></i>
                                        </span>
          {{data.createdOnTS*1000 | date:'h:mm a' }}
        </td>
        <!-- <td class="text-center" style="width: 200px;">
          <div class="widget-content p-0">
            <div class="widget-content-outer">
              <div class="widget-content-wrapper">
                <div class="widget-content-left pe-2">
                  <div class="widget-numbers fsize-1 text-danger">71%</div>
                </div>
                <div class="widget-content-right w-100">
                  <div class="progress-bar-xs progress">
                    <div class="progress-bar bg-danger" role="progressbar" aria-valuenow="71" aria-valuemin="0"
                         aria-valuemax="100" style="width: 71%;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td> -->
        <!-- <td class="text-center">
          <div role="group" class="btn-group-sm btn-group">
            <button class="btn-shadow btn btn-primary">Hire</button>
            <button class="btn-shadow btn btn-primary">Fire</button>
          </div>
        </td> -->
      </tr>
      </tbody>
      <div *ngIf="totalTodaysRegDrivers?.length  == 0" class="text-center  mb-5" >
        <span class="text-danger">Drivers Not Registred</span>
      </div>
    </table>
  </div>
  <div class="d-block p-4 text-center card-footer">
    <button class="btn-pill btn-shadow btn-wide fsize-1 btn btn-dark btn-lg">
      <span class="me-2 opacity-7">
          <i class="fa fa-cog fa-spin"></i>
      </span>
      <span class="me-1">View Complete Report</span>
    </button>
  </div>
</div>

<!-- Todays Registred Users -->
<div class="main-card mb-3 card">
  <div class="card-header">
    <div class="card-header-title font-size-lg text-capitalize fw-normal">Todays Registred Users</div>
  </div>
  <div class="table-responsive" style=" max-height: 400px; overflow-y: auto">
    <table class="align-middle text-truncate mb-0 table table-borderless table-hover">
      <thead>
      <tr>
        <th class="text-center">#</th>
        <th class="text-center">Name</th>
        <th class="text-center">Email</th>
        <th class="text-center">Requirement</th>
        <th class="text-center">Registration Time</th>
      </tr>
      </thead>
      <tbody>
      <tr  *ngFor="let data of todaysUsers;  let i = index " >
        <td class="text-center text-muted" style="width: 80px;">{{i+1}}</td>
        <td class="text-center text-primary" style="width: 80px;">
           {{data.firstName}} {{data.lastName}}
        </td>
        <td class="text-center">{{ data.emailId }}</td>
        <td class="text-center text-success">{{data.requirements}}</td>
        <td class="text-center">
                                        <span class="pe-2 opacity-6">
                                            <i class="fa fa-business-time"></i>
                                        </span>
          {{data.createdOnTS*1000 | date:'h:mm a' }}
        </td>
      </tr>
      </tbody>
      <div *ngIf="todaysUsers?.length  == 0" class="text-center  mb-5" >
        <span class="text-danger">Users Not Registred</span>
      </div>
    </table>
  </div>
</div>

<!-- Todays Trips -->
<div class="main-card mb-3 card">
  <div class="card-header">
    <div class="card-header-title font-size-lg text-capitalize fw-normal">Todays Trips</div>
  </div>
  <div class="table-responsive" style=" max-height: 400px; overflow-y: auto">
    <table class="align-middle text-truncate mb-0 table table-borderless table-hover">
      <thead>
      <tr>
        <th class="text-center">#</th>
        <th class="text-center">Package Id</th>
        <th class="text-center">From Address</th>
        <th class="text-center">Vehicle</th>
        <th class="text-center">To Address</th>
        <th class="text-center">Status</th>
        <th class="text-center">Generated At</th>
        <th class="text-center">Action</th>
      </tr>
      </thead>
      <tbody>
      <tr  *ngFor="let data of todaysPackages;  let i = index " >
        <td class="text-center text-muted" style="width: 80px;">{{i+1}}</td>
        <td class="text-center text-primary" style="width: 80px;">
           {{data.packageID | uppercase}}
        </td>
        <td class="text-center">
          <ng-container *ngIf="data.fromAddress.split(' ').length > 3; else shortAddress">
            {{ data.fromAddress.split(' ').slice(0, 3).join(' ') }}...
          </ng-container>
          <ng-template #shortAddress>
            {{ data.fromAddress }}
          </ng-template>
        </td>
        <td class="text-center text-primary" style="width: 80px;">
          <img width="50" class="rounded-circle" [src]="data.vehicleImage" alt="Vehicle Image">
        </td>
        <td class="text-center text-success">
          <ng-container *ngIf="data.toAddress.split(' ').length > 3; else shortToAddress">
            {{ data.toAddress.split(' ').slice(0, 3).join(' ') }}...
          </ng-container>
          <ng-template #shortToAddress>
            {{ data.toAddress }}
          </ng-template>
        </td>
        <td class="text-center">
          <div class="badge rounded-pill" [ngClass]="{

            'bg-primary': data.status == 0,
            'bg-success': data.status == 1 || data.status == 2 || data.status == 3,
            'bg-info': data.status == 4,
            'bg-danger': data.status == 5
          }">
          {{ 
            data.status == 0 ? 'Generated' : 
            data.status == 1 ? 'Driver Accepted' : 
            data.status == 2 ? 'Trip Started' : 
            data.status == 3 ? 'Completed' : 
            data.status == 4 ? 'User Cancelled' : 
            data.status == 5 ? 'Driver Cancelled' : 'Unknown'
          }}
      
          </div>
        </td>
        <td class="text-center">
                                        <span class="pe-2 opacity-6">
                                            <i class="fa fa-business-time"></i>
                                        </span>
          {{data.timestamp*1000 | date:'h:mm a' }}
        </td>
        <td class="text-center">
          <div role="group" class="btn-group-sm btn-group">
            <button class="btn-shadow btn btn-primary"  (click)="routeViewDetails(data)">View</button>
            <!-- <button class="btn-shadow btn btn-primary">Fire</button> -->
          </div>
        </td>
        
      </tr>
      </tbody>
      <div *ngIf="todaysPackages?.length  == 0" class="text-center  mb-5" >
        <span class="text-danger">Trips Not Generated</span>
      </div>
    </table>
  </div>
</div>

<!-- vehhicle Display -->

<div class="row">
  <div class="col-sm-12 col-lg-12">
    <div class="mb-3 card">
      <div class="card-header-tab card-header">
        <div class="card-header-title font-size-lg text-capitalize fw-normal">
          <i class="header-icon lnr-cloud-download icon-gradient bg-happy-itmeo"> </i>
          Active Vehicles
        </div>
      </div>
      <!-- Display API data -->
      <div class="row p-3">
        <div class="col-md-3 mb-3" *ngFor="let vehicle of allVehicleList">
          <div class="card shadow-sm">
            <img 
              [src]="vehicle.images" 
              class="card-img-top" 
              alt="{{ vehicle.type }} image"
              style="height: 150px; object-fit: cover;" />
            <div class="card-body">
              <h5 class="card-title" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                {{ vehicle.type }}
              </h5>
              <p class="card-text">
                <strong>Capacity:</strong> {{ vehicle.vehicleCapacity }} <br />
                <strong>Dimensions:</strong> {{ vehicle.vehicleSizeDimention }}
              </p>
              <button class="btn btn-primary" (click)="routeViewVehicleDetails(vehicle)">Details</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="card mb-3">
  <div class="g-0 row">
    <div class="col-md-12 col-lg-4">
      <ul class="list-group list-group-flush">
        <li class="bg-transparent list-group-item">
          <div class="widget-content p-0">
            <div class="widget-content-outer">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="widget-heading">Total Todays Orders</div>
                  <!-- <div class="widget-subheading">Last year expenses</div> -->
                </div>
                <div class="widget-content-right">
                  <div class="widget-numbers text-success">{{todaysPackagesCount}}</div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="bg-transparent list-group-item">
          <div class="widget-content p-0">
            <div class="widget-content-outer">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="widget-heading">Total Todays Registred Users</div>
                  <!-- <div class="widget-subheading">Total Clients Profit</div> -->
                </div>
                <div class="widget-content-right">
                  <div class="widget-numbers text-primary">{{todaysUsersCount}}</div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="col-md-12 col-lg-4">
      <ul class="list-group list-group-flush">
        <li class="bg-transparent list-group-item">
          <div class="widget-content p-0">
            <div class="widget-content-outer">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="widget-heading">Total Todays Registred Drivers</div>
                  <!-- <div class="widget-subheading">People Interested</div> -->
                </div>
                <div class="widget-content-right">
                  <div class="widget-numbers text-danger">{{totalPendingDriversCount}}</div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="bg-transparent list-group-item">
          <div class="widget-content p-0">
            <div class="widget-content-outer">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="widget-heading">Total Todays Onboarded Drivers</div>
                  <!-- <div class="widget-subheading">Total revenue streams</div> -->
                </div>
                <div class="widget-content-right">
                  <div class="widget-numbers text-warning">{{todaysOnbordedDriversCount}}</div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="col-md-12 col-lg-4">
      <ul class="list-group list-group-flush">
        <li class="bg-transparent list-group-item">
          <div class="widget-content p-0">
            <div class="widget-content-outer">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="widget-heading">Total Packers Movers Orders</div>
                  <!-- <div class="widget-subheading">Last year expenses</div> -->
                </div>
                <div class="widget-content-right">
                  <div class="widget-numbers text-success">{{packersMoversItemCount}}</div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="bg-transparent list-group-item">
          <div class="widget-content p-0">
            <div class="widget-content-outer">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <!-- <div class="widget-heading">Clients</div> -->
                  <!-- <div class="widget-subheading">Total Clients Profit</div>  -->
                </div>
                <div class="widget-content-right">
                  <!-- <div class="widget-numbers text-primary">$12.6k</div>  -->
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
    <!-- <app-online-drivers></app-online-drivers> -->
</div>
